import React from "react";

export default function XLSIconComponent() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 1.5a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .354.146l2.5 2.5A.5.5 0 0 1 12 4v2h-1V5H8.5a.5.5 0 0 1-.5-.5V2H3v12h8v-.5h1v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm7 .707V4h1.793zM5.4 9.5c-.312.468-.617.929-.856 1.314c-.143.23-.268.443-.359.618a3 3 0 0 0-.118.255A.9.9 0 0 0 4 12h1a.3.3 0 0 1-.007.067l.007-.02q.018-.049.073-.155c.073-.14.182-.327.32-.55c.173-.278.382-.6.607-.939c.225.34.434.66.606.939c.139.223.248.41.321.55a2 2 0 0 1 .08.175A.3.3 0 0 1 7 12h1a.9.9 0 0 0-.067-.313a3 3 0 0 0-.118-.255a10 10 0 0 0-.359-.618c-.24-.385-.544-.846-.855-1.314c.311-.468.616-.929.855-1.314c.143-.23.268-.443.359-.618q.07-.132.118-.255A.9.9 0 0 0 8 7H7c0-.034.005-.057.007-.067L7 6.953a2 2 0 0 1-.073.155a9 9 0 0 1-.32.55c-.173.278-.382.6-.607.939c-.225-.34-.434-.66-.606-.939a9 9 0 0 1-.321-.55a2 2 0 0 1-.08-.175Q4.998 6.95 5 7H4c0 .13.042.248.067.313c.031.081.073.168.118.255c.09.175.216.387.359.618c.24.385.544.846.855 1.314M9.5 11V7h-1v4.5a.5.5 0 0 0 .5.5h1.5v-1zm2-3a1 1 0 0 1 1-1h2v1h-2v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v-1h2v-1h-1a1 1 0 0 1-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
}
